import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import Markdown from '../Richtext/Markdown';
import ImageHandler from '../../utils/ImageHandler';

// ====

const CardEvent = (props) => {
  const { title, image, date, copy, idx } = props;

  function oddOrEven(x) {
    return x & 1 ? 'odd' : 'even';
  }

  const alignment = oddOrEven(idx);

  // ====

  return (
    <div
      className={`w-100 pt-3 pb-3 pt-md-0 pb-md-0 d-flex position-relative brand-timeline-item overflow-hidden ${
        alignment === 'odd' ? 'justify-content-end' : 'justify-content-start'
      }`}
    >
      <div className="brand-timeline-vertical brand-background-blue" />
      <div
        className={`brand-timeline-horizontal ${
          alignment === 'odd'
            ? 'brand-timeline-horizontal-left'
            : 'brand-timeline-horizontal-right'
        }`}
        data-sal="fade"
        data-sal-delay="300"
      />
      <div className="brand-timeline-dot brand-background-blue circle" />
      <div className="col-11 col-md-5">
        <div
          className="card brand-timeline-card brand-card-image-top brand-animation-none"
          data-sal={alignment === 'odd' ? 'slide-left' : 'slide-right'}
          data-sal-delay="0"
          data-sal-easing="easeOutSine"
        >
          <div className="card-header border-0 p-0">
            <div
              className="brand-card-image brand-background-cover"
              style={{
                backgroundImage: `url(${ImageHandler(image, '960x540')})`,
              }}
            />
          </div>
          <div className="card-body">
            {title && <h5 className="brand-font-caps">{title}</h5>}
            {copy && <Markdown>{copy}</Markdown>}
            {date && (
              <p className="brand-font-caps small brand-text-grey m-0">
                <Moment format="MMMM YYYY">{date}</Moment>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardEvent;

// ====

CardEvent.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  copy: PropTypes.string,
  idx: PropTypes.number,
};

CardEvent.defaultProps = {
  title: '',
  date: '',
  copy: '',
  idx: 0,
};
